module.exports = __webpack_public_path__ + "static/media/app-store-icon.dd2be53e.png";